import React from "react";
import { Loader2 } from "lucide-react";

interface FormLoaderProps {
  loading: boolean;
}

export const FormLoader: React.FC<FormLoaderProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/50 backdrop-blur-[1px] rounded-xl">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-10 h-10 text-gold-core animate-spin" />
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-gold-dim animate-pulse">
          Loading Data...
        </p>
      </div>
    </div>
  );
};
